import useAsyncData from "../../../../hooks/use-async-data";
import taxiCorporationService from "../../taxi-corporation.service";
import TaxiCorporationFleetPartnerList from "./taxi-corporation-fleet-partner-list";
import TaxiCorporationFleetPartnerListParams from "./taxi-corporation-fleet-partner-list-params";

const useTaxiCorporationFleetPartnerList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<TaxiCorporationFleetPartnerList>([]);

  const load = async (
    params: TaxiCorporationFleetPartnerListParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const taxiCorporationFleetPartnerList =
        await taxiCorporationService.getFleetPartnerList(params, signal);

      setData(taxiCorporationFleetPartnerList);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useTaxiCorporationFleetPartnerList;
